<header>
    <nav class="navbar navbar-expand-xl navbar-light bg-light">
        <div class="container-fluid">
            <a class="navbar-brand" routerLink="/events">
                <div class="logo-container">
                    <img src="assets/img/logo.svg" alt="logo" class="logo-mono">
                </div>
            </a>

            <button class="navbar-toggler"
                    type="button"
                    (click)="toggleMobileMenu()"
                    [attr.aria-expanded]="isMobileMenuOpen()" aria-label="Toggle navigation">
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div class="collapse navbar-collapse" [class.show]="isMobileMenuOpen()" id="headerNav">
                <ul class="navbar-nav">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button"
                           data-bs-toggle="dropdown" aria-expanded="false">
                            DESPRE
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="https://www.jidvei.ro/istoriejidvei/">ISTORIA JIDVEI</a></li>
                            <li class="dropdown-submenu">
                                <a class="dropdown-item dropdown-toggle" href="#">RĂDĂCINI</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/castelul-bethlen-haller-old/">CASTELUL BETHLEN-HALLER</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/castelul-bethlen-din-sanmiclaus/">CASTELUL BETHLEN DIN SÂNMICLĂUȘ</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/dragon-femeie/">DRAGONUL CU CAP DE FEMEIE</a></li>
                                </ul>
                            </li>
                            <li><a class="dropdown-item" href="https://www.jidvei.ro/cramele-jidvei/">CRAMELE JIDVEI</a></li>
                            <li class="dropdown-submenu">
                                <a class="dropdown-item dropdown-toggle" href="#">ARTA VINULUI</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/artavinului/">INFORMAȚII GENERALE</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/terroir/">TERROIR</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/scoala-de-vita/">ȘCOALA DE VIȚĂ</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/vita-de-vie/">VIȚA-DE-VIE</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/soiuri/">SOIURI</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/plantatiile-jidvei/">PLANTAȚIILE JIDVEI</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.jidvei.ro/category/noutati/">NOUTĂȚI</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.jidvei.ro/castelul-bethlen-haller/">CASTEL</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button"
                           data-bs-toggle="dropdown" aria-expanded="false">
                            COLECȚII
                        </a>
                        <ul class="dropdown-menu">
                            <li class="dropdown-submenu">
                                <a class="dropdown-item dropdown-toggle" href="#">VINURI EXCLUSIVISTE</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/grand-reserve/">GRAND RESERVE</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/vinuri-desert/">VINURI DESERT</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/pinot-noir/">PINOT NOIR</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/owners-choice-10-ani/">OWNER’S CHOICE</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/mysterium/">MYSTERIUM</a></li>
                                </ul>
                            </li>
                            <li class="dropdown-submenu">
                                <a class="dropdown-item dropdown-toggle" href="#">VINURI LINIȘTITE</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/spirit/">SPIRIT</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/vinuri-castel/">CASTEL</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/tezaur-jidvei/">TEZAUR</a></li>
                                    <li><a class="dropdown-item" href="http://jidvei.ro/iluziv">ILUZIV</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/nec-plus-ultra/">NEC PLUS ULTRA</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/grigorescu/">GRIGORESCU</a></li>
                                    <li><a class="dropdown-item" href="https://jidvei.ro/weinland/">WEINLAND</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/clasic/">CLASIC</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/traditional/">TRADIȚIONAL</a></li>
                                </ul>
                            </li>
                            <li class="dropdown-submenu">
                                <a class="dropdown-item dropdown-toggle" href="#">VINURI SPUMANTE</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/spumant-mysterium/">MYSTERIUM</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/spumante-jidvei/">JIDVEI ȘI MĂRGĂRITAR</a></li>
                                    <li><a class="dropdown-item" href="https://www.jidvei.ro/scintti">SCINTTI</a></li>
                                </ul>
                            </li>
                            <li><a class="dropdown-item" href="https://www.jidvei.ro/vinars/">VINARS</a></li>
                            <li><a class="dropdown-item" href="https://www.jidvei.ro/verjus/">VERJUS JIDVEI</a></li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.jidvei.ro/cocktails/">COCKTAILS</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle green" href="#" role="button"
                           data-bs-toggle="dropdown" aria-expanded="false">
                            EVENIMENTE
                        </a>
                        <ul class="dropdown-menu">
                            @for (event of upcomingEvents.value(); track event.id) {
                                <li>
                                    <a class="dropdown-item" [routerLink]="['/events', event.id]" (click)="closeMenus()">
                                        {{ event.name }}
                                    </a>
                                </li>
                            }
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.jidvei.ro/eu-sunt-jidvei/" target="_blank" (click)="closeMenus()">EU SUNT JIDVEI</a>
                    </li>
                    <li class="nav-item d-xl-none" *ngIf="authService.isAuthenticated()">
                        <a class="nav-link" routerLink="/auth/change-password" (click)="closeMenus()">SCHIMBĂ PAROLA</a>
                    </li>
                    <li class="nav-item d-xl-none" *ngIf="authService.isAuthenticated()">
                        <a class="nav-link" (click)="logout()">DECONECTARE</a>
                    </li>
                </ul>
            </div>

            <div class="right-block">
                <div class="icons">
                    <a (click)="goToRegistration()" *ngIf="!authService.isAuthenticated()">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_465_283)">
                                <path d="M17.4777 17.1306C20.1809 17.1306 22.3723 14.9392 22.3723 12.236C22.3723 9.53273 20.1809 7.34131 17.4777 7.34131C14.7744 7.34131 12.583 9.53273 12.583 12.236C12.583 14.9392 14.7744 17.1306 17.4777 17.1306Z"
                                      stroke="black" stroke-width="1.1833" stroke-miterlimit="10"/>
                                <path d="M14.1857 20.0791H21.8136C25.1852 20.0791 27.9224 22.8163 27.9224 26.1879V28.659H8.07715V26.1879C8.07715 22.8163 10.8141 20.0791 14.1857 20.0791Z"
                                      stroke="black" stroke-width="1.1833" stroke-miterlimit="10"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_465_283">
                                    <rect width="36" height="36" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </a>
                    <div class="dropdown" *ngIf="authService.isAuthenticated()">
                        <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_465_283)">
                                    <path d="M17.4777 17.1306C20.1809 17.1306 22.3723 14.9392 22.3723 12.236C22.3723 9.53273 20.1809 7.34131 17.4777 7.34131C14.7744 7.34131 12.583 9.53273 12.583 12.236C12.583 14.9392 14.7744 17.1306 17.4777 17.1306Z"
                                          stroke="black" stroke-width="1.1833" stroke-miterlimit="10"/>
                                    <path d="M14.1857 20.0791H21.8136C25.1852 20.0791 27.9224 22.8163 27.9224 26.1879V28.659H8.07715V26.1879C8.07715 22.8163 10.8141 20.0791 14.1857 20.0791Z"
                                          stroke="black" stroke-width="1.1833" stroke-miterlimit="10"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_465_283">
                                        <rect width="36" height="36" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end user-menu">
                            <li *ngIf="authService.isStaff() && staffUrl">
                                <a class="dropdown-item" [href]="staffUrl + '/staff/dashboard'">
                                    PANOU STAFF
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" routerLink="/dashboard/edit-profile">
                                    PROFILUL MEU
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" routerLink="/events">
                                    EVENIMENTE
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" routerLink="/auth/change-password">
                                    SCHIMBĂ PAROLA
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item small" (click)="logout()">
                                    Deconectare
                                </a>
                            </li>
                        </ul>
                    </div>
                    <a href="#" *ngIf="authService.isAuthenticated()">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_465_289)">
                                <g clip-path="url(#clip1_465_289)">
                                    <path d="M29.3595 10.1294H6.58105V26.3997H29.3595V10.1294Z" stroke="black"
                                          stroke-width="1.25" stroke-miterlimit="10"/>
                                    <path d="M29.3602 12.0205L20.819 18.2644L17.9711 20.3466L15.1232 18.2644L6.58203 12.0205"
                                          stroke="black" stroke-width="1.25" stroke-miterlimit="10"/>
                                    <path d="M29.3605 24.5081L20.8193 18.2642" stroke="black" stroke-width="1.25"
                                          stroke-miterlimit="10"/>
                                    <path d="M15.1232 18.2642L6.58203 24.5081" stroke="black" stroke-width="1.25"
                                          stroke-miterlimit="10"/>
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_465_289">
                                    <rect width="36" height="36" fill="white"/>
                                </clipPath>
                                <clipPath id="clip1_465_289">
                                    <rect width="24.059" height="17.5508" fill="white"
                                          transform="translate(5.94141 9.48901)"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </a>
                </div>
                <div class="button-holder">
                    <a class="btn btn-primary sm" href="https://jidvei.ro/magazin/">MAGAZIN</a>
                </div>
            </div>
        </div>
    </nav>
</header>
